
<!-- tabs components start -->
<div class="tabs">

    <!-- tabs left start -->
    <div class="tabs-left mob-hide">
        <div class="tabs-nav" >
            <div @click="setReport('reports.trades')" class="tabs-nav__item" :class="{'tabs-nav__active': section == 'trades'}">
                <h4>{{ $t('Trades') }}</h4>
            </div>
            <div @click="setReport('reports.deposits')" class="tabs-nav__item" :class="{'tabs-nav__active': section == 'deposits'}">
                <h4>{{ $t('Crypto Deposits') }}</h4>
            </div>
            <div @click="setReport('reports.withdrawals')" class="tabs-nav__item" :class="{'tabs-nav__active': section == 'withdrawals'}">
                <h4>{{ $t('Crypto Withdrawals') }}</h4>
            </div>
            <div @click="setReport('reports.deposits.fiat')" class="tabs-nav__item" :class="{'tabs-nav__active': section == 'fiat_deposits'}">
                <h4>{{ $t('Fiat Deposits') }}</h4>
            </div>
            <div @click="setReport('reports.withdrawals.fiat')" class="tabs-nav__item" :class="{'tabs-nav__active': section == 'fiat_withdrawals'}">
                <h4>{{ $t('Fiat Withdrawals') }}</h4>
            </div>
            <div @click="setReport('reports.referral-transactions')" class="tabs-nav__item" :class="{'tabs-nav__active': section == 'referrals'}">
                <h4>{{ $t('Referrals') }}</h4>
            </div>
            <div @click="setReport('reports.launchpad-transactions')" class="tabs-nav__item" :class="{'tabs-nav__active': section == 'launchpads'}">
                <h4>{{ $t('Launchpads') }}</h4>
            </div>
        </div>
    </div>
    <!-- tabs left end -->

    <div class="form-search__result-block mob-show">
        <div class="form-search__result-title">Select section</div>
        <div class="form-search__result-link">
            <select v-model="tabPage" @change="setTabPage" class="network-select">
                <option value="reports.trades">{{ $t('Trades') }}</option>
                <option value="reports.deposits">{{ $t('Crypto Deposits') }}</option>
                <option value="reports.withdrawals">{{ $t('Crypto Withdrawals') }}</option>
                <option value="reports.deposits.fiat">{{ $t('Fiat Deposits') }}</option>
                <option value="reports.withdrawals.fiat">{{ $t('Fiat Withdrawals') }}</option>
                <option value="reports.referral-transactions">{{ $t('Referrals') }}</option>
                <option value="reports.launchpad-transactions">{{ $t('Launchpads') }}</option>
            </select>
        </div>
    </div>

</div>
<!-- tabs components end -->
